






import { defineComponent, computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import isEmpty from 'lodash/fp/isEmpty'

// Store
import { useSearchStore } from '@/store/search'

// Common
import { firstCharUpperCase } from '@/common/utils/characters'

// Composables
import useSearch from '@/composables/search/useSearch'

export default defineComponent({
  setup() {
    const searchStore = useSearchStore()
    const { isProductTab } = storeToRefs(searchStore)
    const { storedSearchInput } = useSearch()

    const dynamicSearchHeader = computed(() => {
      if (!isEmpty(storedSearchInput.value)) {
        return firstCharUpperCase(searchStore.tabs.selectedTab) + ' results for "' + storedSearchInput.value + '"'
      } else if (isProductTab.value === true) {
        return 'Product Search'
      } else {
        return 'Resources Search'
      }
    })

    return {
      dynamicSearchHeader,
      storedSearchInput,
    }
  },
})
